export type ProductStatus = 'ACTIVE' | 'INACTIVE' | 'DISCONTINUED';

export const ProductStatus = {
  ACTIVE: 'ACTIVE' as ProductStatus,
  INACTIVE: 'INACTIVE' as ProductStatus,
  DISCONTINUED: 'DISCONTINUED' as ProductStatus,
};
